<template>
  <div id="student-list">
    <div class="datatable-form__header datatable-form__header_unmargin">
      <div class="datatable-form__input form-group">
        <!--<label>Student No</label>-->
        <!--<input class="form-control" ref="stud_id">-->
        <vs-input label-placeholder="Student No" v-model="stud_id" v-on:keyup.enter="Search" />
      </div>

      <div class="datatable-form__input form-group">
        <!--<label>Student First Name</label>-->
        <!--<input class="form-control" ref="stud_fname">-->
        <vs-input label-placeholder="Student First Name" v-model="stud_fname" v-on:keyup.enter="Search" />
      </div>

      <div class="datatable-form__input form-group">
        <!--<label>Student Last Name</label>-->
        <!--<input class="form-control" ref="stud_lname">-->
        <vs-input label-placeholder="Student Last Name" v-model="stud_lname" v-on:keyup.enter="Search" />
      </div>

      <div class="datatable-form__input form-group">
        <!--<label>Parent Name</label>-->
        <!--<input class="form-control" ref="stud_parname">-->
        <vs-input label-placeholder="Parent Name" v-model="stud_parname" v-on:keyup.enter="Search" />
      </div>

      <div class="datatable-form__submit text-center">
        <button class="btn btn-success searchbtn" id="btnSearch" v-on:click="Search">Search</button>
      </div>
    </div>

    <div class="datatable-form__header">
      <div class="datatable-form__input form-group">
        <el-select placeholder="Select Batch" v-model="classType" class="ddlSearchStatus">
          <el-option v-for="classTypeListInfo in classTypeList" :key="classTypeListInfo" :label="classTypeListInfo" :value="classTypeListInfo"> </el-option>
        </el-select>
      </div>

      <div class="datatable-form__input form-group">
        <el-select placeholder="Select Class" v-model="classID" class="ddlSearchStatus">
          <el-option
            v-for="classListInfo in classList"
            :key="classListInfo.PK_Class_ID"
            :label="classListInfo.CLS_ClassName"
            :value="classListInfo.PK_Class_ID"
          >
          </el-option>
        </el-select>
      </div>

      <div class="datatable-form__input form-group">
        <el-select placeholder="Select Level" v-model="levelID" class="ddlSearchStatus">
          <el-option
            v-for="levelListInfo in levelList"
            :key="levelListInfo.PK_Course_ID"
            :label="levelListInfo.CRS_Course_Name"
            :value="levelListInfo.PK_Course_ID"
          >
          </el-option>
        </el-select>
      </div>

      <div class="datatable-form__input form-group">
        <el-select placeholder="Select Status" v-model="statusSearch" class="ddlSearchStatus" @change="Search">
          <el-option v-for="statusSearchListInfo in statusSearchList" :key="statusSearchListInfo" :label="statusSearchListInfo" :value="statusSearchListInfo">
          </el-option>
        </el-select>
      </div>
    </div>

    <div style="display: none">{{ stud_id }}</div>

    <div class="mt-5 container" :class="{ 'admin-wrap': listCount > 0 }">
      <div class="row header mb-2" v-if="listCount > 0">
        <div class="col-lg-5">
          <h3 class="text-left mb-3">Student List</h3>
        </div>
        <div class="col-lg-7 actionDiv">
          <div class="text-right student-search-count">
            Total <span>{{ listCount }}</span> Students
          </div>
          <el-popover placement="bottom-end" width="600" trigger="click">
            <el-checkbox-group v-model="studentFilter[0].value" class="custom-checkbox">
              <el-checkbox-button v-for="item in studentFilterItem" :label="item" :key="item" :value="item">{{ item }} </el-checkbox-button>
            </el-checkbox-group>
            <el-button slot="reference" type="primary" round class="float-right large-btn classManage-filter mr-2"
              ><i class="material-icons"> tune </i> Filter
            </el-button>
          </el-popover>
        </div>
      </div>
      <div class="emptylist-info" v-if="listCount === 0">
        <span>PLEASE SEARCH TO VIEW LIST...</span>
        <div class="emptylist__img">
          <img src="../assets/table-loading.png" />
        </div>
      </div>

      <div v-if="listCount > 0" class="datatable_group">
        <data-tables :data="list" :action-col="actionCol" @selection-change="handleSelectionChange" :filters="studentFilter">
          <el-table-column
            v-for="studentListInfo in studentList"
            :prop="studentListInfo.prop"
            :label="studentListInfo.label"
            :key="studentListInfo.prop"
            sortable="custom"
          >
          </el-table-column>
        </data-tables>
      </div>
    </div>

    <el-button
      type="primary"
      class="btn btn-primary waves-effect waves-light m-r-10 float-left"
      style="display: none"
      @click="studentListPageVueUpdateLevelClassTourStart()"
    >
      Guided Tour - UpdateLevelClass
    </el-button>

    <v-tour
      name="StudentListPageUpdateLevelClassVueTourName"
      :steps="studentListPageUpdateLevelClassVueTour"
      :options="studentListPageUpdateLevelClassVueTourOptions"
      :callbacks="studentListPageUpdateLevelClassVueTourCallBacks"
    >
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.currentStep === index"
            v-for="(step, index) of tour.steps"
            :key="index"
            :step="step"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
          >
            <template v-if="tour.currentStep === 0">
              <div slot="actions">
                <button class="v-step__button" @click="tour.stop">Close</button>
                <!--<button class="v-step__button" @click="studentListPageUpdateLevelClassVueTourCallBacksNextPage()">Next</button>-->
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
  </div>
</template>

<script>
import DataSource from '../data/datasource'

export default {
  name: 'StudentList',
  data() {
    return {
      statusSearchList: ['', 'Active', 'Closed', 'Pending', 'Withdrawn', 'Graduated', 'Waitlist', 'Void', 'Rejected', 'Blacklist'],
      statusSearch: '',
      list: [],
      listCount: '',
      Father_Name: '',
      studentList: [
        {
          prop: 'Index_No',
          label: 'Student ID',
        },
        {
          prop: 'Full_Name',
          label: 'First Name',
        },
        {
          prop: 'Last_name',
          label: 'Last Name',
        },
        {
          prop: 'FatherFullName',
          label: 'Father Name',
        },
        {
          prop: 'MotherFullName',
          label: 'Mother Name',
        },
        {
          prop: 'Status',
          label: 'Status',
        },
        {
          prop: 'levelAndClassName',
          label: 'Class (Level)',
        },
      ],
      actionCol: {
        label: 'Edit',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-edit',
            },
            handler: row => {
              if (this.$route.query.mode === 'Search') {
                if (this.$route.query.tour === 'UpdateLevelClass') {
                  this.$router.push('student?id=' + row.Student_ID + '&tour=UpdateLevelClass')
                } else {
                  this.$router.push('student?id=' + row.Student_ID)
                }
              } else if (this.$route.query.mode === 'Course') {
                this.$router.push('student-edit-level?id=' + row.Student_ID)
              } else {
                alert('Error! Please try again later')
              }
            },
            label: 'Edit',
          },
          // {
          //     props: {
          //         type: 'primary',
          //         icon: 'el-icon-document'
          //     },
          //     handler: row => {
          //         this.isModalOpen = true;
          //         this.Father_Name = row.Father_Name;
          //         console.log(this.Father_Name);
          //     },
          //     label: 'View'
          // }
        ],
      },
      selectedRow: null,
      stud_id: '',
      stud_fname: '',
      stud_lname: '',
      stud_parname: '',
      studentFilter: [
        {
          value: [],
          prop: 'Status',
        },
      ],
      studentFilterItem: [],

      //vue tour Update Level Class
      studentListPageUpdateLevelClassVueTourOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: 'Skip tour',
          buttonPrevious: 'Previous',
          buttonNext: 'Next',
          buttonStop: 'Finish',
        },
      },
      studentListPageUpdateLevelClassVueTourCallBacks: {
        onPreviousStep: this.studentListPageUpdateLevelClassVueTourCallBacksPreviousSteps,
        onNextStep: this.studentListPageUpdateLevelClassVueTourCallBacksNextSteps,
      },
      studentListPageUpdateLevelClassVueTour: [
        {
          target: '#btnSearch',
          content: `<div>Step 1 / 3 <br>Fill the searching info and click Search button</div>`,
          params: {
            placement: 'top',
          },
        },
      ],
      //vue tour Update Level Class

      classType: '',
      classTypeList: [],
      classID: '',
      classList: [],
      levelID: '',
      levelList: [],
    }
  },
  async mounted() {
    this.getClassType()
    this.getClass()
    this.getLevel()

    window.addEventListener('load', () => {
      if (this.$route.query.tour === 'UpdateLevelClass') {
        this.studentListPageVueUpdateLevelClassTourStart()
      }
    })
  },
  methods: {
    handleSelectionChange(val) {
      this.selectedRow = val
    },
    async Search() {
      this.$vs.loading()
      try {
        const response = await DataSource.shared.getStudentWithPendingCourse(
          '',
          this.stud_id,
          this.stud_fname,
          this.stud_lname,
          this.stud_parname,
          this.statusSearch,
          this.levelID,
          this.classID,
          this.classType,
        )
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Search Student: Error',
            })
          } else if (response.code === '2') {
            this.$notify.error({
              title: 'No Record',
              message: 'No Student Found',
            })
          } else {
            this.list = response.Table
            this.listCount = response.Table && response.Table.length
            this.list.forEach(object => {
              const found = this.studentFilterItem.find(d => d === object.Status)
              if (!found) {
                this.studentFilterItem.push(object.Status)
              }
            })
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },
    studentListPageVueUpdateLevelClassTourStart() {
      this.$tours['StudentListPageUpdateLevelClassVueTourName'].start()
    },
    studentListPageUpdateLevelClassVueTourCallBacksPreviousSteps(currentStep) {
      let finalSteps = currentStep - 1

      this.windowsSrollUpdateLevelClass(finalSteps)
    },
    studentListPageUpdateLevelClassVueTourCallBacksNextSteps(currentStep) {
      let finalSteps = currentStep + 1

      this.windowsSrollUpdateLevelClass(finalSteps)
    },
    studentListPageUpdateLevelClassVueTourCallBacksNextPage() {
      window.location.replace('/student?id=TOURDEMO')
    },
    windowsSrollUpdateLevelClass(finalSteps) {
      // if (finalSteps >= 0 && finalSteps <= 1) {
      //     this.activeTab = 'Level';
      // }
    },
    async getClassType() {
      try {
        const response = await DataSource.shared.getClassType('')
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.classTypeList.push('')

            response.Table.forEach(object => {
              this.classTypeList.push(object.CTY_ClassType)
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async getClass() {
      try {
        const response = await DataSource.shared.getClass('')
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            let classListDetials = {
              PK_Class_ID: '',
              CLS_ClassName: '',
            }

            this.classList.push(classListDetials)

            response.Table.forEach(object => {
              classListDetials = {
                PK_Class_ID: object.PK_Class_ID,
                CLS_ClassName: object.CLS_ClassName,
              }

              this.classList.push(classListDetials)
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async getLevel() {
      try {
        const response = await DataSource.shared.getLevel('')
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            let levelListDetials = {
              PK_Course_ID: '',
              CRS_Course_Name: '',
            }

            this.levelList.push(levelListDetials)

            response.Table.forEach(object => {
              levelListDetials = {
                PK_Course_ID: object.PK_Course_ID,
                CRS_Course_Name: object.CRS_Course_Name,
              }

              this.levelList.push(levelListDetials)
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },
  },
}
</script>

<style>
#student-list .vs-con-input {
  text-align: left;
}

#student-list .vs-input--placeholder {
  color: rgba(255, 255, 255, 0.6);
}

#student-list .isFocus .vs-placeholder-label {
  color: #fff;
}

/*jess*/
.action-list button {
  /*width: 100%;*/
  margin: 5px 0px;
}

.sc-table .action-list > span + span {
  margin: 0px 0px;
  display: block;
}

.ddlSearchStatus .el-input__inner {
  color: white;
  height: 37px;
  border: 1px solid;
  border-color: rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  top: 1px;
  position: relative;
  width: auto;
}

.datatable-form__header_unmargin {
  margin: 0 !important;
}
</style>
